module.exports = __webpack_public_path__ + "img/vehicleLicenseI-fail.c9c25666.png";